 import Mainpage from './mainpage.vue'
 import Category from './category.vue'
 import Categoryorg from './categoriesorg.vue'
 import Bag from './bag.vue'
 import Order from './order.vue'
 import Orderconfirm from './orderconfirm.vue'
 import Orderdetails from './orderdetails.vue'
 import Account from './account.vue'
 import Login from './login.vue'
 import Address from './address.vue'
 import Products from './products.vue'
 import Ordertest from './ordertest.vue'
 import Autosuggest from './autosuggest.vue'
  import Productsdetails from './productsdetails.vue'
  import Cancelorder from './cancelorder.vue'
  import Ordermob from  './ordersmob.vue'
import Addresses from './addresses.vue'
import Deals from './deals.vue'
import Whishlist from './whishlist.vue'
import Contact from './contact.vue'
import About from './about.vue'
import Terms from './terms.vue'
import Privacypolicy from './privacypolicy.vue'
import Refundpolicy from './refundpolicy.vue'
import Returnexchange from './returnexchange.vue'
import Shipping from './shipping.vue'
import Paymentfailure from './paymentfailure.vue'

 
 
 

  export default[
  

  {
  	path:'/',component:Mainpage
  },

  {
    path:'/shipping',component:Shipping
  },

{
    path:'/refundpolicy',component:Refundpolicy
  },

{
    path:'/returnexchange',component:Returnexchange
  },

 {
    path:'/privacypolicy',component:Privacypolicy
  },

  {
    path:'/termsconditions',component:Terms
  },


  {
    path:'/about',component:About
  },

{
    path:'/contact',component:Contact
  },


  {
    path:'/whishlist',component:Whishlist
  },
   
   {
    path:'/category',component:Category
  },

   {
    path:'/deals/:categoryname',component:Deals
  },
   {
    path:'/addresses',component:Addresses,
      meta:{
      requiresAuth:true
    }
  },
   {
    path:'/categories/',component:Categoryorg
  },

   {
    path:'/bag',component:Bag
  },
  {
    path:'/account',component:Account,
      meta:{
      requiresAuth:true
    }

  },  
   {
    path:'/suggest',component:Autosuggest
  },  
  {
    path:'/orders',component:Ordermob,

    meta:{
      requiresAuth:true
    }
  },  
  {
    path:'/orderdetails/:orderid',component:Orderdetails,

    meta:{
      requiresAuth:true
    }
  },  
  {
    path:'/orderdetails/:orderid/cancel-order',component:Cancelorder,

    meta:{
      requiresAuth:true
    }
  },  
   {
    path:'/login',component:Login
  },  
  {
    path:'/ordersuccess',component:Orderconfirm,
      meta:{
      requiresAuth:true
    }
  },  
  {
    path:'/paymentfailure',component:Paymentfailure,
      meta:{
      requiresAuth:true
    }
  },  
   {
    path:'/ordertest/:orderid',component:Ordertest,name:'test'
  },  
  {
    path:'/categories/:categoryname',component:Products
  },  
   {
    path:'/productsdetails/:categoryname/:id',component:Productsdetails
  },  
 {
    path:'/address',component:Address,
      meta:{
      requiresAuth:true
    }

  },  


  ]

/*  {

    path:'/myorder',component:myorder,

    meta:{
      requiresAuth:true
    }
  } 



  ,
  {

    path:'/meetview',component:meetview
  } 
  */




// WEBPACK FOOTER //
// ./src/routes.js